'use strict';

import { environment } from '@quartz-iam-legacy/environments/environment';

angular.module('systemOwnerReviewControllers.ConfirmSystemOwnership')

.factory('confirmSystemOwnershipService', ['$http', '$q', function ($http, $q) {

    var service = {};

    var baseUrl = environment.apiUrl + '/ID/SystemOwner/Review/API';

    // **** HttpPost

    service.addNewBackupSystemOwner = function (authLogin, backupEmployeeId, systems) {
        var systemIdList = _.map(systems, 'SystemID');

        return $http.post(baseUrl + '/BySystemOwner/' + authLogin +
                          '/SystemOwner/Backup', {
                              backupEmployeeId: backupEmployeeId,
                              systemIdList: systemIdList
                          })
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.removeBackupSystemOwner = function (authLogin, backupEmployeeId, systems) {
        var systemIdList = _.map(systems, 'SystemID');

        return $http.post(baseUrl + '/BySystemOwner/' + authLogin +
                          '/SystemOwner/Backup/Remove', {
                                  backupEmployeeId: backupEmployeeId,
                                  systemIdList: systemIdList
                          })
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.replaceBackupSystemOwners = function (authLogin, backupEmployees, systems) {
        var backupEmployeeIdList = _.map(backupEmployees, 'EmployeeID');
        var systemIdList = _.map(systems, 'SystemID');

        return $http.post(baseUrl + '/BySystemOwner/' + authLogin +
                          '/SystemOwner/Backup/Replace', {
                              backupEmployeeIdList: backupEmployeeIdList,
                              systemIdList: systemIdList
                          })
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.changePrimarySystemOwner = function (authLogin, primaryEmployeeId, systems) {
        var systemIdList = _.map(systems, 'SystemID');

        return $http.post(baseUrl + '/BySystemOwner/' + authLogin +
                          '/SystemOwner/Primary', {
                              primaryEmployeeId: primaryEmployeeId,
                              systemIdList: systemIdList
                          })
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.confirmReview = function (authLogin, primaryEmployeeId, systems) {
        var systemIdList = _.map(systems, 'SystemID');

        return $http.post(baseUrl + '/BySystemOwner/' + authLogin +
                          '/SystemOwner/Confirm', {
                              primaryEmployeeId: primaryEmployeeId,
                              systemIdList: systemIdList
                          })
                    .then(function (response) {
                        return response.data;
                    });
    }

    return service;
}]);
